/* eslint-disable @typescript-eslint/naming-convention */
export enum BeautySupplementCategory {
	"美容サプリメント（美容を目的とした粒・錠剤、カプセル、粉末・パウダーなど）",
	"健康サプリメント（健康やダイエットを目的とした粒・錠剤、カプセル、粉末・パウダーなど）",
	"美容ドリンク（美容を目的とした飲料）",
	"健康ドリンク（健康を目的とした飲料）",
	"栄養ドリンク（栄養補給・滋養強壮を目的とした飲料）",
	"エナジードリンク（清涼飲料水）",
	"美容ゼリー・グミ（美肌や肌ケアを目的としたゼリー・グミ食品）",
	"栄養補助食品・ゼリー（栄養補給を目的とした食品・ゼリー）",
}
